import { secondsToHms } from './utils';

/**
 * Get Track position of the flag in HH:MM:SS format
 *
 * @param trackPosition - Track position of flag
 * @returns Track position in HH:MM:SS format or 00:00:00 if trackPosition is -1
 */
export function secondsToHmsCheck(trackPosition: number) {
  if (trackPosition === -1) {
    return secondsToHms(0);
  } else {
    return secondsToHms(trackPosition);
  }
}
